
import { loadMomentTimeZone } from '~/fc/ExternalScripts'
export default {
  name: 'TimeChart',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    source: {
      default: null,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    target: {
      default: null,
      required: true
    }
  },
  data: () => ({
    hours: [],
    moment: null
  }),
  computed: {
    info () { return this.$store.state.info }
  },
  mounted () {
    loadMomentTimeZone((moment) => {
      this.moment = moment
    })
    for (let i = 0; i < 24; i++) {
      this.hours.push(i)
    }
  },
  methods: {
    formatTime (time, abbr) {
      if (time === '12:00 am') {
        return `12:00 am ${abbr} (${this.$t('midnight')})`
      } else if (time === '12:00 pm') {
        return `12:00 pm ${abbr} (${this.$t('noon')})`
      }
      return `${time} ${abbr}`
    },
    showSourceTime (hour) {
      const d = new Date()
      d.setHours(hour)
      d.setMinutes(0)
      return this.formatTime(this.moment(d).format('hh:mm a'), this.source.abbr)
    },
    showTargetTime (hour) {
      const d = new Date()
      const source = this.moment.tz(d, this.source.name).hours(hour).minutes(0)

      return this.formatTime(
        this.moment.tz(source, this.target.name).format('hh:mm a'),
        this.target.abbr
      )
    }

  }
}
